module.exports = __webpack_public_path__ + "img/form_wechat.bdbdf060.png";